<template>
  <div class="textarea-chart">
    <p v-if="end >= 200" style="text-align: center">注意:更多详情请导出原始数据查看</p>
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="编号"
          width="200">
          <template slot-scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column
          prop="text"
          label="文本填答">
          <template slot-scope="scope">{{scope.row}}</template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="mb40">
      <div class='pager-center'>
        <el-pagination @current-change='getList' :current-page.sync='currentPage' :page-size='pageSize' layout='prev, pager, next, jumper' :total='totalItem'>
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'textareaChart',
  props: ['quesInfo'],
  data() {
    return {
      textList: this.quesInfo.textList,
      pageSize: 10,
      currentPage: 1,
      totalItem: this.quesInfo.textList.length,
      tableData: [],
      start:0,
      end:0
    }
  },
  mounted(){
    this.getList()
  },
  methods: {
    getList() {
      this.start = (this.currentPage - 1) * this.pageSize;
      this.end = this.start + this.pageSize;
      this.tableData = this.textList.slice(this.start, this.end);
    }
  }
}
</script>

<style lang="scss" scoped>
  .textarea-chart {
    .mb40 {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/singleAnalysis/textareaChart.vue